/**
 * メールアドレス入力を正規化する: 全角→半角 (NFKC), 空白・ゼロ幅文字の除去
 *
 * 例: "ｕｓｅｒ＠example.com" (末尾に全角スペース) → "user@example.com"
 */
export const normalizeEmailInput = (value: unknown) =>
  typeof value === 'string'
    ? value.normalize('NFKC').replace(/[\s\u200B-\u200D\u2060\uFEFF]/g, '')
    : value

/**
 * formData の email を正規化済みの値に差し替えたコピーを返す (TOTP 認証に渡す用)
 */
export const withNormalizedEmail = (formData: FormData, email: string) => {
  const copied = new FormData()
  formData.forEach((value, key) => copied.append(key, value))
  copied.set('email', email)
  return copied
}
